import { render, staticRenderFns } from "./dsOrder.vue?vue&type=template&id=e00b3830&scoped=true"
import script from "./dsOrder.vue?vue&type=script&lang=js"
export * from "./dsOrder.vue?vue&type=script&lang=js"
import style0 from "./dsOrder.vue?vue&type=style&index=0&id=e00b3830&prod&lang=less&scoped=true"
import style1 from "./dsOrder.vue?vue&type=style&index=1&id=e00b3830&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00b3830",
  null
  
)

export default component.exports